import {
	IAddNoteAccountInformation,
	ICalculateSubcriptionParams,
	IChangeStatusChildAccount,
	IDownLoadAccountStatementParams,
	IDownLoadCashTransactionParams,
	IDownLoadTokenTransactionParams,
	IEditNotification,
	IListPaySubscriptionBody,
	INewNotification,
	IRequest,
	ISubmitRiskDeclaration,
	ITransferTokenOmnibusAccount,
} from "./types";
import { axiosInstance } from "api/axios";
import { QueryConfig } from "react-query";

export const CreateNotification = async (request: INewNotification): Promise<any> => {
	const response = await axiosInstance.post(`/omnibus-account/notification`, request);
	return response;
};

export const UpdateNotification = async (request: IEditNotification): Promise<any> => {
	const response = await axiosInstance.put(
		`/omnibus-account/notification/${request.id}`,
		request,
	);
	return response;
};

export const PublishNotification = async (id: string): Promise<any> => {
	const response = await axiosInstance.put(`/omnibus-account/notification/${id}/publish`);
	return response;
};

export const downloadAllStatement = async (id: string): Promise<any> => {
	const response = await axiosInstance.get(
		`/omnibus-account/cash-transaction/download-all/${id}`,
		{
			responseType: "arraybuffer",
		},
	);
	return response;
};

export const downloadCashTransactionPDF = async (
	params: IDownLoadCashTransactionParams,
): Promise<any> => {
	const response = await axiosInstance.post(`/omnibus-account/cash-transaction/detail`, params, {
		responseType: "arraybuffer",
	});
	return response;
};

export const downloadTokenTransactionPDF = async (
	params: IDownLoadTokenTransactionParams,
): Promise<any> => {
	const response = await axiosInstance.post(`/omnibus-account/token-transaction/detail`, params, {
		responseType: "arraybuffer",
	});
	return response;
};

export const addNoteAccountInformation = async (
	request: IAddNoteAccountInformation,
): Promise<any> => {
	const response = await axiosInstance.post(
		`/omnibus/children/${request?.childId}/account-info/note`,
		{
			content: request?.content,
		},
	);
	return response;
};

export const changeStatusChildAccount = async (
	request: IChangeStatusChildAccount,
): Promise<any> => {
	const response = await axiosInstance.put(
		`/omnibus/children/${request?.childUserId}/status`,
		request,
	);
	return response;
};

export const uploadFileForChildAccount = async (request: any): Promise<any> => {
	const response = await axiosInstance.post(`/document-tracker`, request, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
	return response;
};

export const transferCashTransferOmnibusAccount = async (
	request: ITransferTokenOmnibusAccount,
): Promise<any> => {
	const response = await axiosInstance.post(`/omnibus-account/transfer`, request);
	return response;
};

export const transferTokenTransferOmnibusAccount = async (request: any): Promise<any> => {
	const response = await axiosInstance.post(`/omnibus-account/token-transfer`, request);
	return response;
};

export const downloadAllAccountStatements = async (
	params: IDownLoadAccountStatementParams,
): Promise<any> => {
	const data = await axiosInstance.get(
		`/omnibus-account/total-statement/download/${params?.childId}`,
		{
			params,
			responseType: "arraybuffer",
		},
	);
	return data;
};

export const createChildAccount = async (request: any): Promise<any> => {
	const response = await axiosInstance.post(`/omnibus/accounts/child`, request);
	return response;
};

export const useDownloadAccountManagement = async (params: any): Promise<any> => {
	const data = await axiosInstance.get(`/omnibus/accounts/children/download`, {
		params,
		responseType: "arraybuffer",
	});
	return data;
};

export const previewFileUpload = async (request: any): Promise<any> => {
	const formData = new FormData();
	formData.append("file", request.file);
	const response = await axiosInstance.post(
		`/omnibus/accounts/children-with-file/preview`,
		formData,
	);
	return response;
};

export const useDownloadFilePreview = async (request: any): Promise<any> => {
	const formData = new FormData();
	formData.append("file", request.file);
	const data = await axiosInstance.post(
		`/omnibus/accounts/children-with-file/download`,
		formData,
		{
			responseType: "arraybuffer",
		},
	);
	return data;
};

export const useDownloadSubcriptionPreview = async (request: any): Promise<any> => {
	const formData = new FormData();
	formData.append("file", request.file);
	const data = await axiosInstance.post(
		`/omnibus-accounts/project/${request.id}/subscription/download`,
		formData,
		{
			responseType: "arraybuffer",
		},
	);
	return data;
};

export const useDownloadSubcriptionAmountBasedPreview = async (request: any): Promise<any> => {
	const formData = new FormData();
	formData.append("file", request.file);
	const data = await axiosInstance.post(
		`/omnibus-accounts/project/${request.id}/subscription/amount-based/download`,
		formData,
		{
			responseType: "arraybuffer",
		},
	);
	return data;
};

export const createBulkUpload = async (request: any): Promise<any> => {
	const formData = new FormData();
	formData.append("file", request.file);
	const response = await axiosInstance.post(
		`/omnibus/accounts/children-with-file/create`,
		formData,
	);
	return response;
};

export const previewFileUploadOmnibusAccount = async (request: IRequest): Promise<any> => {
	const formData = new FormData();
	formData.append("file", request.file);
	const response = await axiosInstance.post(
		`/omnibus-accounts/project/${request.id}/subscription/preview`,
		formData,
	);
	return response;
};

export const previewAmountBasedFileUploadOmnibusAccount = async (
	request: IRequest,
): Promise<any> => {
	const formData = new FormData();
	formData.append("file", request.file);
	const response = await axiosInstance.post(
		`/omnibus-accounts/project/${request.id}/subscription/amount-based/preview`,
		formData,
	);
	return response;
};

export const useDownloadFilePreviewOmnibusAccount = async (request: IRequest): Promise<any> => {
	const formData = new FormData();
	formData.append("file", request.file);
	const data = await axiosInstance.post(
		`/omnibus-accounts/project/${request.id}/subscription/download`,
		formData,
		{
			responseType: "arraybuffer",
		},
	);
};

export const calculateSubscription = async (
	params: ICalculateSubcriptionParams,
	options?: QueryConfig<any, any>,
) => {
	const { data } = await axiosInstance.get(`/omnibus-account/subscription/calculate`, {
		params,
		...options,
	});
	return data;
};

export const paySubscription = async (request: IListPaySubscriptionBody) => {
	const data = await axiosInstance.post(`omnibus-account/subscription`, request);
	return data;
};

export const getMetadataTransactionActivity = async () => {
	const { data } = await axiosInstance.get(`/metadata/admin-transaction-activities`);
	return data;
};

export const submitRiskDeclaration = async (request: ISubmitRiskDeclaration): Promise<any> => {
	const response = await axiosInstance.post(`/omnibus-account/risk-declaration`, request);
	return response;
};
